<template>
  <div class="mx-3 ma-4">
    <v-card class="pa-5">
      <v-card-title>
        Purchase Returns
        <v-spacer></v-spacer>
        <v-btn color="#00B3FF" dark depressed @click="createReturn">Create Return</v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="10"
        :loading="loading"
        :hide-default-footer="true"
        :disable-sort="true"
        :disable-pagination="true"
      >
        <template v-slot:item="{ item, index }">
          <tr :class="index % 2 === 0 ? 'dark-row' : 'light-row'" class="custom-row" @click="viewDetails(item)" style="cursor: pointer;">
            <td class="text-left">{{ item.return_number }}</td>
            <td class="text-left">{{ item.return_date }}</td>
            <td class="text-left">{{ item.invoice_number || '-' }}</td>
            <td class="text-left">{{ item.reason_for_return || '-' }}</td>
            <td class="text-left">{{ currencyCode }}{{ formatNumber(item.grand_total) }}</td>
          </tr>
        </template>
      </v-data-table>

      <v-alert v-if="!loading && items.length === 0" type="info" class="mt-5" outlined>
        No purchase returns found.
      </v-alert>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");
import { CustomerService } from "@/services/customer-service.js";

export default {
  name: "PurchaseReturns",
  data() {
    return {
      items: [],
      loading: false,
      headers: [
        { text: "Return Number", value: "return_number", align: "start" },
        { text: "Date", value: "return_date", align: "start" },
        { text: "Related Invoice", value: "invoice_number", align: "start" },
        { text: "Reason", value: "reason_for_return", align: "start" },
        { text: "Refund Amount", value: "grand_total", align: "start" },
      ],
    };
  },
  computed: {
    ...mapSettingsGetters(["currencyCode"]),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    createReturn() {
      this.$router.push({
        name: "CustomerReturnCreate",
        params: { uuid: this.$route.params.uuid },
      });
    },
    viewDetails(item) {
      this.$router.push({
        name: "CustomerReturnDetails",
        params: { uuid: this.$route.params.uuid, returnUuid: item.uuid },
      });
    },
    fetchData() {
      this.loading = true;
      CustomerService.getCustomerReturns(this.$route.params.uuid)
        .then((res) => {
          this.loading = false;
          this.items = res.data.data || [];
        })
        .catch(() => {
          this.loading = false;
          this.items = [];
        });
    },
  },
};
</script>

<style scoped>
.dark-row { background-color: #fafafa; }
.light-row { background-color: #ffffff; }
.custom-row { height: 60px; border: none; }
</style>
